var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mode,{tag:"component",attrs:{"lang":_vm.lang}})
}
var staticRenderFns = []

export { render, staticRenderFns }